import { searchBoxStyles } from "@insite/content-library/Widgets/Addresses/AddressBookSearchBox";
import Search from "@insite/mobius/Icons/Search";
import { css } from "styled-components";

searchBoxStyles.searchText = {
    css: css`
      max-height: 40px !important;
    `,
    iconProps: { src: Search },
}